import React, { useEffect } from "react";
import {
  Box,
  Container,
  Typography,
  Paper,
  CircularProgress,
  Button,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import { useTranslation } from "react-i18next";
import { enqueueSnackbar } from "notistack";
import SnackbarConfig from "../../utils/snackbarConfig";
import { getApplicationSettings } from "../../services/apiManager/apiRequests";
import apiConfig from "../../services/apiManager/apiConfig";
import logo from "../../assets/safe_logo.png";
import { useState } from "react";

const Maintenance = () => {
  const { t } = useTranslation();
  const [checkingStatus, setCheckingStatus] = useState(false);

  const checkMaintenanceStatus = async () => {
    setCheckingStatus(true);
    try {
      const resp = await getApplicationSettings(apiConfig.appSettings);
      const settings = resp?.appSettings;

      if (settings?.maintenanceLevel !== 5) {
        enqueueSnackbar(
          "Maintenance is complete! Redirecting...",
          SnackbarConfig.success,
        );
        setTimeout(() => {
          window.location.href = "/";
        }, 2000);
      } else {
        enqueueSnackbar(
          "System is still under maintenance",
          SnackbarConfig.info,
        );
      }
    } catch (err) {
      enqueueSnackbar(
        "Error checking maintenance status",
        SnackbarConfig.error,
      );
    } finally {
      setCheckingStatus(false);
    }
  };

  useEffect(() => {
    checkMaintenanceStatus();
  }, []);

  return (
    <Container
      maxWidth="md"
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 4,
          width: "100%",
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
          <img
            src={logo}
            alt="Safe Truck Parking"
            style={{ maxWidth: "200px" }}
          />
        </Box>

        <Paper
          elevation={3}
          sx={{
            p: { xs: 3, md: 4 },
            width: "100%",
            maxWidth: "600px",
            textAlign: "center",
          }}
        >
          <Typography
            variant="h4"
            component="h1"
            gutterBottom
            sx={{
              fontWeight: "bold",
              color: "primary.main",
              mb: 3,
            }}
          >
            System Maintenance
          </Typography>

          <Typography
            variant="h6"
            sx={{
              mb: 2,
              color: "text.secondary",
            }}
          >
            We're currently performing scheduled maintenance
          </Typography>

          <Typography
            variant="body1"
            sx={{
              mb: 4,
              color: "text.secondary",
            }}
          >
            Please check back later. We apologize for any inconvenience.
          </Typography>

          <Button
            variant="outlined"
            startIcon={
              checkingStatus ? <CircularProgress size={20} /> : <RefreshIcon />
            }
            onClick={checkMaintenanceStatus}
            disabled={checkingStatus}
            color="primary"
            sx={{
              minWidth: "200px",
              whiteSpace: "nowrap",
              px: 2,
            }}
          >
            Check Status
          </Button>
        </Paper>
      </Box>
    </Container>
  );
};

export default Maintenance;
